import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdsComponent } from './ads/ads.component';
import { ClientsComponent } from './clients/clients.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'clients',
        pathMatch: 'full'
    },
    {
        path: 'clients',
        component: ClientsComponent,
        data: {
            title: 'clients'
        }
    },
    {
        path: 'publicidad',
        component: AdsComponent,
        data: {
            title: 'Publicidad'
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class WifiRoutingModule { }
